module.exports = __webpack_public_path__ + "static/img/GettyImages-726797925.a96c619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/GettyImages-726797925.jpg
// module id = QC9k
// module chunks = 0